import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Services', path: '/services' },
  { label: 'Pricing', path: '/pricing' },
  { label: 'Contact', path: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-300"
      style={{
        background: scrolled ? '#ffffff' : 'transparent',
        borderBottom: scrolled ? '1px solid rgba(0,0,0,0.08)' : 'none',
      }}
    >
      <div className="px-6 md:px-12 lg:px-16 py-5 flex items-center justify-between">
        <Link
          to="/"
          className="text-black text-xs tracking-widest uppercase whitespace-nowrap cursor-pointer"
          style={{ fontFamily: 'Syne, sans-serif', fontWeight: 700, letterSpacing: '0.13em' }}
        >
          NOVA AI DIGITAL LLC
        </Link>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8 lg:gap-10">
          {navLinks.map(({ label, path }) => (
            <Link
              key={path}
              to={path}
              className="text-[11px] uppercase tracking-widest transition-all duration-200 cursor-pointer whitespace-nowrap"
              style={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: location.pathname === path ? 600 : 400,
                color: location.pathname === path ? '#000' : 'rgba(0,0,0,0.5)',
                letterSpacing: '0.12em',
              }}
            >
              {label}
            </Link>
          ))}
        </nav>

        {/* Mobile menu button */}
        <button
          className="md:hidden text-black text-xs uppercase tracking-widest flex items-center gap-2 cursor-pointer whitespace-nowrap"
          style={{ fontFamily: 'Inter, sans-serif', letterSpacing: '0.12em' }}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          Menu
          <span className="flex flex-col gap-1.5">
            <span
              className="block w-5 h-px bg-black transition-all duration-300"
              style={{ transform: menuOpen ? 'rotate(45deg) translate(2px, 4px)' : 'none' }}
            />
            <span
              className="block w-5 h-px bg-black transition-all duration-300"
              style={{ opacity: menuOpen ? 0 : 1 }}
            />
            <span
              className="block w-5 h-px bg-black transition-all duration-300"
              style={{ transform: menuOpen ? 'rotate(-45deg) translate(2px, -4px)' : 'none' }}
            />
          </span>
        </button>
      </div>

      {/* Mobile dropdown */}
      <div
        className="md:hidden overflow-hidden transition-all duration-400 bg-white border-t border-black/8"
        style={{ maxHeight: menuOpen ? '400px' : '0' }}
      >
        <div className="px-6 py-6 flex flex-col gap-0">
          {navLinks.map(({ label, path }) => (
            <Link
              key={path}
              to={path}
              className="py-4 border-b border-black/8 text-[11px] uppercase tracking-widest text-black cursor-pointer"
              style={{ fontFamily: 'Inter, sans-serif', letterSpacing: '0.12em' }}
            >
              {label}
            </Link>
          ))}
        </div>
      </div>
    </header>
  );
}
